import { useMutation, useQueryClient } from "@tanstack/react-query"
import { classes } from  '@shared/api/services'
import { toast } from 'react-toastify'

export const useRemoveAppointment = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => classes.cancelClass(data),
		onSuccess: () => {
			toast.success('Занятие отменено')
			queryClient.invalidateQueries({ queryKey: ['appointments'] })
			queryClient.invalidateQueries({ queryKey: ['history'] })
			queryClient.invalidateQueries({ queryKey: ['upcoming-appointments'] })
		},
		onError: (err) => {
			toast.error(err?.response?.data?.message || 'Ошибка сервера. Попробуйте позже')
		},
	})

	return mutation
}